import { View } from 'react-native'
import Animated, {
  SharedValue,
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated'

const ModalBackdrop = ({
  children,
  animation,
  intensity = 64,
  enabled,
}: {
  animation: SharedValue<number>
  children?: React.ReactNode
  intensity?: number
  enabled?: boolean
}) => {
  const style = useAnimatedStyle(() => {
    return {
      backdropFilter: `blur(${interpolate(
        animation.value,
        [0, 100],
        [0, intensity]
      )}px)`,
      opacity: interpolate(animation.value, [0, 100], [0, 1]),
    }
  })

  return (
    <>
      {intensity > 0 && enabled && (
        <Animated.View
          className="pointer-events-none absolute left-0 top-0 z-10 h-full w-full"
          style={[
            {
              backgroundColor: `rgba(0, 0, 0, ${(intensity / 100) * 0.75})`,
              // backdropFilter: `blur(64px)`,
            },
            style,
          ]}
        />
      )}
      <View className="pointer-events-none absolute left-0 top-0 z-20 h-full w-full flex-1 justify-center">
        {children}
      </View>
    </>
  )
}

export default ModalBackdrop
